module.exports = __webpack_public_path__ + "static/media/thumbnail_rumi-ii-koh@3x.69788dc5.jpg";